module.exports = __webpack_public_path__ + "1694f9cbe04b5a4ab6b87ed3012fd731.MP3";